'use client'

import { DownloadCloud } from 'lucide-react'
import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ImportDialog } from './ImportDialog'

interface RouteImportButtonProps {
	/**
	 * Optional extra classes for the trigger button. Pass `"border-brand"` to
	 * give it the purple gradient emphasis edge when it's the primary call to
	 * action on a screen.
	 */
	className?: string
}

/**
 * The single entry point the estimator imports for the route-import flow
 * (file upload or pasted itinerary). Owns nothing but the open/closed state of the dialog —
 * every step of the actual import lives inside {@link ImportDialog}, keeping
 * this component trivial (and well under the cognitive-complexity ceiling).
 */
export default function RouteImportButton({ className }: RouteImportButtonProps) {
	const [open, setOpen] = useState(false)

	return (
		<>
			<Button
				type="button"
				variant="default"
				className={cn('w-full', className)}
				onClick={() => setOpen(true)}
			>
				<DownloadCloud className="size-4" aria-hidden />
				Import
			</Button>
			<ImportDialog open={open} onOpenChange={setOpen} />
		</>
	)
}
